import React, { memo, useEffect } from "react";
import { notification } from "antd";
import { useNavigate } from "react-router";
import { useNotification } from "../../../hooks/useNotification";
import { ReactComponent as ErrorIcon } from "../../../assets/images/NoticeErrorIcon.svg";
import { ReactComponent as WarningIcon } from "../../../assets/images/NoticeWarningIcon.svg";
import { ReactComponent as InfoIcon } from "../../../assets/images/NoticeInfoIcon.svg";
import { ReactComponent as SuccessIcon } from "../../../assets/images/NoticeSuccessIcon.svg";

import ErrorMapContent from "../../CustomErrorMessages/ErrorMapContent";
import FooterNotification from "./FooterNotification";

import { usePublicConfig } from "../../../hooks/usePublicConfig";
import { SHOPIFY_ENV } from "../../../utils";

import { Container, Description, Message } from "./styles";

const Notification = () => {
  const { env } = usePublicConfig();
  const isShopify = SHOPIFY_ENV.includes(env?.hostEnv);
  const navigate = useNavigate();
  const noticeData = useNotification();
  const [api, contextHolder] = notification.useNotification();

  const typeConfig = {
    info: {
      style: {
        border: "1px solid #00AEEF",
        background: "#F1FCFF",
      },
      icon: <InfoIcon />,
    },
    warning: {
      style: {
        border: "1px solid #FDB022",
        background: "#FFFAEB",
      },
      icon: <WarningIcon />,
    },
    error: {
      style: {
        border: "1px solid #FCA5A5",
        background: "#FEF3F2",
      },
      icon: <ErrorIcon />,
    },
    danger: {
      style: {
        border: "1px solid #8e0b21",
        background: "#fee8eb",
      },
      icon: <ErrorIcon />,
    },
    success: {
      style: {
        border: "1px solid #148757",
        background: "#ECFDF3",
      },
      icon: <SuccessIcon />,
    },
  };

  const openNotificationWithIcon = (type) => {
    const config = typeConfig[type] || typeConfig.error;
    const antdTypes = ["success", "info", "warning", "error"];
    const method = antdTypes.includes(type) ? type : "open";

    api[method]({
      message: (
        <Message>
          {noticeData?.details?.title ??
            noticeData?.data?.error?.details?.title ??
            noticeData.status}
        </Message>
      ),
      description: (
        <>
          <Description>
            <ErrorMapContent
              error={noticeData?.data?.error?.message ?? "Something went wrong"}
              variables={noticeData?.data?.error?.details?.variables}
              dangerouslySetInnerHTML={
                noticeData?.message ??
                noticeData?.error ??
                noticeData?.data?.error?.message
              }
              onClose={notification.destroy}
            />
          </Description>
          <FooterNotification faqLink={noticeData?.data?.error?.details?.faq} />
        </>
      ),
      duration: 0,
      style: { width: 653, borderRadius: 8, padding: "16px", ...config.style },
      icon: config.icon,
    });
  };

  useEffect(() => {
    if (noticeData) {
      const type = isShopify ? "danger" : "error";
      openNotificationWithIcon(type);
    } else {
      api.destroy();
    }
  }, [noticeData, isShopify]);

  useEffect(() => {
    if (noticeData?.data?.error?.details?.redirect_path) {
      setTimeout(() => {
        navigate(noticeData?.data?.error?.details?.redirect_path);
      }, 3000);
    }
  }, [noticeData?.data?.error?.details?.redirect_path]);

  useEffect(() => {
    if (noticeData?.data?.error?.details?.redirect_url) {
      navigate(noticeData?.data?.error?.details?.redirect_url);
    }
  }, [noticeData?.data?.error?.details?.redirect_url]);

  return <Container>{contextHolder}</Container>;
};

export default memo(Notification);
